function titleCase(str) {

	if (typeof str !== 'string') {
		return ''
	}

	let splitStr = str.toLowerCase().split(' ')

	for (let i=0; i<splitStr.length; i++) {
		splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
	}

	return splitStr.join(' ')
}

export default titleCase
